import(/* webpackMode: "eager" */ "/codebuild/output/src692692924/src/doctor-dashboard/app/global-error.tsx");
